export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.c950f5cdcfc95f5a5261a82826a786be.css";